/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthenticationStrictHttpResponse } from '../../authentication-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EntraExternalIdAccessTokenResponse } from '../../models/entra-external-id-access-token-response';
import { UserPregistrationRequestModel } from '../../models/user-pregistration-request-model';

export interface EntraExternalDRegisterUserFromPreRegistrationPost$Params {
      body?: UserPregistrationRequestModel
}

export function entraExternalDRegisterUserFromPreRegistrationPost(http: HttpClient, rootUrl: string, params?: EntraExternalDRegisterUserFromPreRegistrationPost$Params, context?: HttpContext): Observable<AuthenticationStrictHttpResponse<EntraExternalIdAccessTokenResponse>> {
  const rb = new RequestBuilder(rootUrl, entraExternalDRegisterUserFromPreRegistrationPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AuthenticationStrictHttpResponse<EntraExternalIdAccessTokenResponse>;
    })
  );
}

entraExternalDRegisterUserFromPreRegistrationPost.PATH = '/EntraExternalD/RegisterUserFromPreRegistration';
